import FullCalendar from "@fullcalendar/react";
import React from "react";
import dayGridPlugin from "@fullcalendar/daygrid";
import jaLocale from "@fullcalendar/core/locales/ja";
import "../calendar.css";
import { calculateDailyResults } from "../utils/trainingResultsCalculations";
import { formatScore } from "../utils/formatting";
import interactionPlugin from "@fullcalendar/interaction";
import { useTheme } from "@mui/material";
import { isSameMonth } from "date-fns";

const Calendar = ({
  monthlyTransactions,
  setCurrentMonth,
  setCurrentDay,
  currentDay,
  today,
}) => {
  const theme = useTheme();
  const events = [
    { title: "Meeting", start: new Date() },
    { title: "Meeting", start: "2026-05-20", upperBody: 300, lowerBody: 400 },
  ];

  // 1か月のトレーニングデータを日付ごとに集計
  const dailyResults = calculateDailyResults(monthlyTransactions);

  const createCalendarEvents = (dailyResults) => {
    return Object.keys(dailyResults).map((date) => {
      const { upperBody, lowerBody, cardio } = dailyResults[date];
      return {
        start: date,
        upperBody: formatScore(upperBody),
        lowerBody: formatScore(lowerBody),
        cardio: formatScore(cardio),
      };
    });
  };

  const calendarEvents = createCalendarEvents(dailyResults);

  // カレンダーの今日、前月、次月ボタンを押した時の処理
  const handleDateSet = (datesetInfo) => {
    const currentMonth = datesetInfo.view.currentStart;
    setCurrentMonth(currentMonth);
    const todayDate = new Date();
    if (isSameMonth(todayDate, currentMonth)) {
      setCurrentDay(today);
    }
  };

  // カレンダーをクリックした時に日付を状態管理する
  const handleDateClick = (dateInfo) => {
    setCurrentDay(dateInfo.dateStr);
  };

  const backgroundEvent = {
    start: currentDay,
    display: "background",
    backgroundColor: theme.palette.cardio.light,
  };

  const renderEventContent = (eventInfo) => {
    return (
      <div>
        <div className="workout" id="event-upperBody">
          {eventInfo.event.extendedProps.upperBody}
        </div>
        <div className="workout" id="event-lowerBody">
          {eventInfo.event.extendedProps.lowerBody}
        </div>
        <div className="workout" id="event-cardio">
          {eventInfo.event.extendedProps.cardio}
        </div>
      </div>
    );
  };
  return (
    <FullCalendar
      locale={jaLocale}
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      events={[...calendarEvents, backgroundEvent]}
      eventContent={renderEventContent}
      datesSet={handleDateSet}
      dateClick={handleDateClick}
    />
  );
};

export default Calendar;
